<template>
  <div class="container-fluid">
    <!-- Navigation -->
    <div class="row" style="margin-bottom: 5.5%">
      <div class="col">
        <nav
          class="navbar navbar-expand-lg navbar-light bg-light shadow fixed-top"
        >
          <div class="container">
            <!-- <a class="navbar-brand" href="#">{{ cliente.apelidoUnico }}</a> -->
            <button
              class="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarResponsive"
              aria-controls="navbarResponsive"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarResponsive">
              <ul class="navbar-nav ml-auto">
                <li class="nav-item" v-if="pessoa == null">
                  <router-link
                    class="nav-link"
                    :to="{
                      name: 'LoginPage',
                      params: { apelidoCliente: `${cliente.apelidoUnico}` },
                    }"
                  >
                    Login
                  </router-link>
                </li>

                <li class="nav-item active" v-if="pessoa != null && !pessoa.bloquearNavegacao ">
                  <router-link
                    class="nav-link"
                    :to="{
                      name: 'ListagemFormulario',
                      params: { apelidoCliente: `${cliente.apelidoUnico}` },
                    }"
                  >
                    Início
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link
                    v-if="pessoa"
                    class="nav-link"
                    :to="{
                      name: 'CadastroPessoaPage',
                      params: { apelidoCliente: `${cliente.apelidoUnico}` },
                    }"
                  >
                    Cadastro
                  </router-link>
                </li>
                <li class="nav-item text-danger" v-if="pessoa">
                  <a class="nav-link" href="#" @click="handleClickSair">Sair</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
    <br />

    <!-- Full Page Image Header with Vertically Centered Content -->
    <header
      class="masthead rounded"      
      :style="{
        backgroundColor: corPrimariaTopo,
        borderColor: corPrimariaTopo,
      }"  >
      
      <img v-if="urlLogo" :src="urlLogo" style="max-width: 100%;" class="mx-auto d-block" />
    </header>

    <div class="row">
      <div class="col">
        <!-- Page Content -->
        <section class="py-3">
          <div>
            <router-view></router-view>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import notificacaoService from "../../services/Notificacao.service";
import storageService from "../../services/storageService";
import { USER_CONFIG } from "../../config/UserConfig";
import { configuracaoTemaMixin } from "../../components/ConfiguracaoTemaMixin";
export default {
  mixins: [configuracaoTemaMixin],
  mounted() {
    if(this.isDebug)
      console.log("corPrimariaTopocorPrimariaTopo", this.corPrimariaTopo);
  },
  updated(){
    
    if(this.isDebug)
      console.log("algo atualizou na main", this.pessoa.deveAtualizarCelular)

    if(this.pessoa.deveAtualizarCelular && this.pessoa.bloquearNavegacao) {
      this.$router.push({ name: "CadastroPessoaPage" });
    }
  },
  computed: {
    cliente() {
      return this.$store.state.clienteFormulario;
    },

    pessoa() {
      const { participante } = this.$store.state;
      if (participante && participante.pessoaId) return participante;
      return null;
    },
  },
  methods: {
    handleClickSair() {
      const confirmacao = notificacaoService.confirmacao(
        "Deseja realmente sair?",
        ""
      );
      confirmacao.then((ok) => {
        if (ok.value) {
          storageService.removeItem(USER_CONFIG.loggedUser);
          storageService.removeItem(USER_CONFIG.token);
          this.$store.dispatch("descarregarFormulario", 0);
          this.$router.push({
            name: `LoginPage`,
            params: { apelidoCliente: this.cliente.apelidoUnico },
          });
        }
      });
    },
  },
};
</script>

<style scoped>

.masthead {
  /* height: 10vh; 
  min-height: 30px;   */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: white;
  font-weight: bold;
  margin-top: 2.1vh;
}

@media (min-width: 320px) and (max-width: 480px) {
  
  /* CSS */
  header {    
    margin-top: 2.5vh;    
  }
  
}

/* 
  ##Device = Tablets, Ipads (portrait)
  ##Screen = B/w 768px to 1024px
*/

@media (min-width: 768px) and (max-width: 1024px) {
  
  header {    
    margin-top: 2.8vh;    
  }

  
}

/* 
  ##Device = Tablets, Ipads (landscape)
  ##Screen = B/w 768px to 1024px
*/

@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  
  header {    
    margin-top: 2.8vh;    
  }
  
}


</style>




// WEBPACK FOOTER //
// src/View/AreaLogada/MainPage.vue